import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 8,
			height: 24,
			fill: "#002B7F"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 8,
			width: 8,
			height: 24,
			fill: "#FCD116"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 16,
			width: 8,
			height: 24,
			fill: "#CE1126"
		})
	]
});
export default SvgRo;
